import styled from 'styled-components';
import { Flex, Input } from '@zillow/constellation';

export const StyledInput = styled(Input)`
    height: 40px;
    width: 30px;
    margin-right: 4px;
    text-align: center;
    padding: 0;

    &:focus {
        padding: 0;
    }
`;

export const StyledFlex = styled(Flex)`
    height: 42px;
`;
